module.exports = __webpack_public_path__ + "img/f2ca572.jpg";